import { Cell, DeprecatedIcon, Text } from '@vinted/web-ui';
import useTracking from 'hooks/useTracking';
import useTranslate from 'hooks/useTranslate';
import FaqEntryUrl from 'components/FaqEntryUrl';
import UserInfoBlock from 'pages/Profile/InfoHeader/UserInfoBlock';
import { FaqEntryType } from 'constants/faq-entry';
import { donationsClickEvent } from 'libs/common/event-tracker/events';
import { ClickableElement } from 'constants/tracking/clickable-elements';
import { Screen } from 'constants/tracking/screens';
import { jsx as _jsx } from "react/jsx-runtime";
const ScreenToTarget = {
  [Screen.UserProfile]: ClickableElement.DonationsAboutUserProfile,
  [Screen.UserAbout]: ClickableElement.DonationsAboutUserInfo
};

const FundraiserInfo = _ref => {
  var _user$fundraiser;

  let {
    user,
    screen,
    styling
  } = _ref;
  const translate = useTranslate('user');
  const {
    track
  } = useTracking();

  const handleClick = event => {
    if (!(event.target instanceof HTMLAnchorElement)) return;
    const trackingEvent = donationsClickEvent({
      screen,
      target: ScreenToTarget[screen]
    });
    track(trackingEvent);
  };

  if (!((_user$fundraiser = user.fundraiser) !== null && _user$fundraiser !== void 0 && _user$fundraiser.active)) return null;
  return /*#__PURE__*/_jsx(FaqEntryUrl, {
    type: FaqEntryType.Donations,
    render: url => /*#__PURE__*/_jsx(Cell, {
      onClick: handleClick,
      styling: styling,
      children: /*#__PURE__*/_jsx(UserInfoBlock, {
        iconName: "donate-filled",
        iconColor: DeprecatedIcon.Color.Success,
        children: /*#__PURE__*/_jsx(Text, {
          text: translate('donating', {
            username: user.login,
            'faq-url': chunk => /*#__PURE__*/_jsx("a", {
              href: url,
              children: chunk
            })
          })
        })
      })
    })
  });
};

export default FundraiserInfo;